import React from 'react';
import { Bell, BellOff } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useNotifications, type Notification } from '@/contexts/NotificationContext';
import { ScrollArea } from "@/components/ui/scroll-area";
import { format } from 'date-fns';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
export function NotificationCenter() {
  const {
    notifications,
    markAsRead,
    removeNotification,
    clearAll
  } = useNotifications();
  const unreadCount = notifications.filter(n => !n.read).length;
  const handleNotificationClick = (notification: Notification) => {
    if (!notification.read) {
      markAsRead(notification.id);
    }
  };
  return <DropdownMenu>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" className="relative">
                <Bell className="h-5 w-5" />
                {unreadCount > 0 && <span className="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-red-500 text-[10px] font-medium text-white flex items-center justify-center">
                    {unreadCount}
                  </span>}
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent className="bg-accent text-accent-foreground text-xs py-2 px-3">
            <p>Notifications</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <DropdownMenuContent align="end" className="w-80">
        <div className="flex items-center justify-between px-4 py-2 border-b">
          <h2 className="font-semibold">Notifications</h2>
          {notifications.length > 0 && <Button variant="ghost" size="sm" onClick={clearAll} className="text-sm text-muted-foreground hover:text-foreground">
              Clear all
            </Button>}
        </div>
        <ScrollArea className="h-[300px]">
          {notifications.length === 0 ? <div className="h-full flex flex-col items-center justify-center p-4 text-sm text-muted-foreground space-y-2 my-[101px]">
              <BellOff className="h-8 w-8 text-muted-foreground" />
              <p>No notifications</p>
            </div> : notifications.map(notification => <DropdownMenuItem key={notification.id} className={`flex flex-col items-start p-4 space-y-1 cursor-pointer ${!notification.read ? 'bg-muted/50' : ''}`} onClick={() => handleNotificationClick(notification)}>
                <div className="flex items-center justify-between w-full">
                  <p className="text-sm font-medium">{notification.message}</p>
                  <Button variant="ghost" size="icon" className="h-6 w-6" onClick={e => {
              e.stopPropagation();
              removeNotification(notification.id);
            }}>
                    ×
                  </Button>
                </div>
                <p className="text-xs text-muted-foreground">
                  {format(notification.timestamp, 'MMM d, h:mm a')}
                </p>
              </DropdownMenuItem>)}
        </ScrollArea>
      </DropdownMenuContent>
    </DropdownMenu>;
}